import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import axios from 'axios';

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import MapComponent from "../components/GoogleMap";
import PropertyCard from "../components/propertycard";
import PropertySearch from "../components/propertysearch";
import PageHeader from "../components/pageheader";

//const apiPath = 'http://localhost:5286/DimoraProperties';
//const apiPath = 'https://dimoralivingwebapi.azurewebsites.net/dimoraproperties';
const apiPath = 'https://dimoraliving.com/dimoraproperties';

function removeDuplicates(arr)
{
    const uniqueObjects = [];
    const seenObjects = new Set();

    for(const obj of arr)
    {
        const stringOfObj = JSON.stringify(obj);
        if(!seenObjects.has(stringOfObj)){
            uniqueObjects.push(obj);
            seenObjects.add(stringOfObj);
        }
    }
    return uniqueObjects;
}

export default function PropertyListing() {

    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);    
    const propertySearchTypeURLParam = searchParams.get('propertyType');
    
    const [properties, setProperties] = useState([]);
    const [mapMarkers, setMapMarkers] = useState([]);
    const [propertySearchType, setPropertySearchType] = useState(propertySearchTypeURLParam);
    const [propertyBedrooms, setPropertyBedrooms] = useState(0);
    const [propertyBathrooms, setPropertyBathrooms] = useState(0);
    const [propertyAddress, setPropertyAddress] = useState("");
    const [propertyAvailability, setPropertyAvailability] = useState(0)
    const [selectedMapCoords,  setSelectedMapCoords] = useState({ lat:0, lng:0 });
    const [showLoader, setShowLoader] = useState(false);
    
    //const apiPostPath = `${apiPath}?rentalType=${propertySearchType}&bedrooms=0&bathrooms=0`;
    
    const handleReload = () => {
        navigate('/temp', {replace: true});
        navigate(`${location.pathname}${location.search}`, {replace: true});
    };

    const handleSelectedLocationChanged = (data) => 
        setPropertyAddress(data);
    
    const handleSelectedBedroomsChanged = (data) =>  
        setPropertyBedrooms(data);

    const handleSelectedBathroomsChanged = (data) =>  
        setPropertyBathrooms(data);
    
    const handleSelectedPropertyTypeChanged = (data) =>
        setPropertySearchType(data);
    
    const handleSelectedPropertyAvailabilityChanged = (data) =>
        setPropertyAvailability(data);
    
    const handlePropertyClicked = data => {
        if(typeof data === 'undefined') return;
        setSelectedMapCoords(prevState => ({ ...prevState, ...data}))
    }
    
    const fetchData = async (apiPostPath) => {
        
        try {

            setShowLoader(true);
            
            // grab data from api and place into state
            const response = await axios.post(apiPostPath);
            const data = response.data;
            const newArray = [...data];
            setProperties(newArray);

            setShowLoader(false);
            
        } catch (error) {
            console.log(error);
        }
    }    
    
    useEffect(() =>{
        setPropertySearchType(propertySearchType);
        let apiPostPath = `${apiPath}?rentalType=${propertySearchType}&location=${propertyAddress}&bedrooms=${propertyBedrooms}&bathrooms${propertyBathrooms}&availability=${propertyAvailability}`;
        
        fetchData(apiPostPath);
    }, [])
    
    useEffect(() => {
        let apiPostPath = `${apiPath}?rentalType=${propertySearchType}&location=${propertyAddress}&bedrooms=${propertyBedrooms}&bathrooms=${propertyBathrooms}&availability=${propertyAvailability}`;
        fetchData(apiPostPath);        
    }, [propertyAddress, propertyBathrooms, propertyBedrooms, propertySearchType, propertyAvailability])
    
    useEffect(() => {
        
        let myMarkers = properties.map(item => ({
            key: item.address,
            location: {
                lat: item.lat,
                lng: item.lng
            }
        }))
        
        // remove duplicate coordinates
        myMarkers = removeDuplicates(myMarkers);
        setMapMarkers(prevState => [...myMarkers]);
        
    }, [properties])
    
    return (
        <>
            <Navbar navClass="defaultscroll sticky" menuClass = "navigation-menu nav-right"/>
            <PageHeader />
            <section className="section">
                <div className="container-no-right-hand-padding">
                    <div className="row g-4">
                        
                        <div className="col-lg-8 col-md-7 col-12 mt-100">
                            <PropertySearch
                                onSelectedPropertyTypeChanged={handleSelectedPropertyTypeChanged}
                                onSelectedLocationChanged={handleSelectedLocationChanged} 
                                onSelectedBedroomsChanged={handleSelectedBedroomsChanged} 
                                onSelectedBathroomsChanged={handleSelectedBathroomsChanged} 
                                onSelectedAvailabilityChanged={handleSelectedPropertyAvailabilityChanged} 
                            />
                            {/* HOUSE CARDS  */}
                            <div className="row g-4 mt-0">
                                {showLoader ? <span className="loader"></span> :  
                                    properties.length === 0 ? <h6 style={{fontSize: "14pt", fontWeight:"bold"}}>Nothing fits your parameters</h6> :
                                    properties.map((item, index) => {
                                        return (
                                            <PropertyCard 
                                                item={item} 
                                                key={index} 
                                                onPropertyClicked={handlePropertyClicked} 
                                            />
                                        )
                                    })}
                            </div>
                        </div>

                        {/* COLUMN GOES HERE*/}
                        <div className="col-lg-4 col-md-5 col-12">
                            <div className="card map border-0 sticky-bar-400">
                                <div className="card-body p-0">
                                    {mapMarkers.length > 0 ? <MapComponent markers={mapMarkers} selectedMapCoords={selectedMapCoords} /> : null }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            <Footer/>
        </>)
}